<ng-template #spinner>
   <mat-spinner id="spinnerAttachments" diameter="30"></mat-spinner>
</ng-template>

<mat-expansion-panel id="attachments" class="bordered" [class.invalid]="(shipment.highlightInvalid$ | async) && attachments.invalid" *ngIf="( shipment.shipmentForm$ | async ).get( 'attachments' ) as attachments">
   <mat-expansion-panel-header>
      <mat-panel-title id="attachmentPanelTitle">
         {{shipment?.configs?.attachments?.label ?? 'Attachments'}} <lib-info id="attachmentTooltip" (click)="$event.stopPropagation()"></lib-info>
      </mat-panel-title>
   </mat-expansion-panel-header>

   <ng-container *ngIf="shipment.shipmentForm$ | async as shipmentForm else spinner">
      <lib-attachment-create [form]="shipmentForm.get('attachments')" [attachmentTypesEnum]="enums.attachmentTypes(shipment.shipType, shipment.mode)"></lib-attachment-create>
   </ng-container>
</mat-expansion-panel>
